import { render, staticRenderFns } from "./Respostas.vue?vue&type=template&id=2d19c334&scoped=true&"
import script from "./Respostas.vue?vue&type=script&lang=js&"
export * from "./Respostas.vue?vue&type=script&lang=js&"
import style0 from "./Respostas.vue?vue&type=style&index=0&id=2d19c334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d19c334",
  null
  
)

export default component.exports